import { render, staticRenderFns } from "./WhatToDo.vue?vue&type=template&id=b0318980&scoped=true&"
import script from "./WhatToDo.vue?vue&type=script&lang=js&"
export * from "./WhatToDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatToDo.vue?vue&type=style&index=0&id=b0318980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0318980",
  null
  
)

export default component.exports